import { render, staticRenderFns } from "./ComponentGroups.vue?vue&type=template&id=5c5175ab&scoped=true"
import script from "./ComponentGroups.vue?vue&type=script&lang=js"
export * from "./ComponentGroups.vue?vue&type=script&lang=js"
import style0 from "./ComponentGroups.vue?vue&type=style&index=0&id=5c5175ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5175ab",
  null
  
)

export default component.exports